<nav class="navbar navbar-expand-lg navbar-light no-gutters">
  <a class="navbar-brand m-0" href="#"><img class="img-fluid" src="/assets/images/logo.png"></a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse " id="navbarSupportedContent">
    <ul class="navbar-nav  m-auto">
      <li class="nav-item ">
        <a class="nav-link" routerLink="/home" >HOME <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">CONTACT</a>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          Meals
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item p-2" routerLink='breakfast'>Break fast</a>
          <a class="dropdown-item p-2" routerLink='mainCourse'>Main course</a>
          <a class="dropdown-item p-2" routerLink='salad'>Salads</a>
          <a class="dropdown-item p-2" routerLink='snack'>Snacks</a>
          <a class="dropdown-item p-2" routerLink='sideDish'>Side dishes</a>
        </div>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle"  id="navbarDropdown" role="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          Diets
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" routerLink='glutenFreeRecipes'>Gluten free</a>
          <a class="dropdown-item" routerLink='ketogenicRecipes'>KetoGeneic</a>
          <a class="dropdown-item" routerLink='vegetarianRecipes'>Vegeterian</a>
          <a class="dropdown-item" routerLink='veganRecipes'>Vegan</a>
          <hr class="w-100">
          <a class="dropdown-item" routerLink='lactovegetarianRecipes'>Lacto-Vegeterian</a>
          <a class="dropdown-item" routerLink='ovoVegetarianRecipes'>Ovo-Vegeterian</a>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link " href="#">INFO</a>
      </li>

    </ul>
    <div>
      <ul class="navbar-nav">
        <li class="nav-item dropdown " [ngClass]="{'user-token' : token == true}">
          <a class="nav-link dropdown-toggle gen-btn reg-btn text-center" href="#" id="navbarDropdown" role="button"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            REGISTER
          </a>
          <div class="dropdown-menu " aria-labelledby="navbarDropdown">
            <a class="dropdown-item" routerLink="/login">Login</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/register"> Signup</a>
            <!-- <a class="dropdown-item" routerLink="/profile"> Profile</a> -->
          
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="user-img" [ngClass]="{'user-token' : token == false}">
    <a routerLink="/profile" routerLinkActive="router-link-active" > <img class="w-100" src="{{user.photo}}" alt="profileimage"></a>
  </div>
  <div class=" Logout " [ngClass]="{'user-token' : token == false}">
    <a class="nav-link" (click)="logout()"  style="cursor: pointer;">Logout</a>
  </div>

</nav>
